<template>
  <!-- begin:: Aside -->
  <div
    class="aside aside-left aside-fixed d-flex flex-column flex-row-auto"
    id="kt_aside"
    ref="kt_aside"
    @mouseover="mouseEnter"
    @mouseleave="mouseLeave"
  >
    <!-- begin:: Aside -->
    <KTBrand></KTBrand>
    <!-- end:: Aside -->

    ```
    <!-- begin:: Aside Menu -->
    <div
      class="aside-menu-wrapper flex-column-fluid"
      id="kt_aside_menu_wrapper"
    >
      <div
        ref="kt_aside_menu"
        id="kt_aside_menu"
        class="aside-menu"
        data-menu-vertical="1"
        data-menu-dropdown-timeout="500"
        v-bind:class="asideMenuClass"
      >
        <div class="toggle-button">
          <button
            class="btn btn-icon btn-lg custom-toggle-btn"
            id="kt_aside_toggle"
            @click="toggleAside"
          >
            <i id="toggle-icon" class="fas fa-chevron-left"></i>
          </button>
        </div>

        <!-- example static menu here -->
        <perfect-scrollbar
          class="aside-menu scroll"
          style="max-height: 90vh; position: relative"
        >
          <KTMenu></KTMenu>
        </perfect-scrollbar>
      </div>
    </div>
    ```
  </div>
  <!-- end:: Aside -->
</template>

<script>
import KTBrand from "@/view/layout/brand/Brand.vue";
import { mapGetters } from "vuex";

import KTLayoutAsideMenu from "@/assets/js/layout/base/aside-menu.js";
import KTLayoutAside from "@/assets/js/layout/base/aside.js";
import KTMenu from "@/view/layout/aside/Menu.vue";

export default {
  name: "KTAside",
  data() {
    return {
      insideTm: 0,
      outsideTm: 0,
    };
  },
  components: {
    KTBrand,
    KTMenu,
  },
  mounted() {
    this.$nextTick(() => {
      const asideRef = this.$refs["kt_aside"];

      // Init Aside
      KTLayoutAside.init(asideRef);

      asideRef.querySelectorAll("a[class='menu-link']").forEach((item) => {
        item.addEventListener("click", () => {
          KTLayoutAside.getOffcanvas().hide();
        });
      });

      // Init Aside Menu
      KTLayoutAsideMenu.init(this.$refs["kt_aside_menu"]);
    });
  },
  methods: {
    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    mouseEnter() {
      if (this.layoutConfig("aside.self.minimize.hoverable")) {
        // check if the left aside menu is fixed
        if (document.body.classList.contains("aside-fixed")) {
          if (this.outsideTm) {
            clearTimeout(this.outsideTm);
            this.outsideTm = null;
          }

          // // if the left aside menu is minimized
          // if (document.body.classList.contains("aside-minimize")) {
          //   document.body.classList.add("aside-minimize-hover");

          //   // show the left aside menu
          //   document.body.classList.remove("aside-minimize");
          // }
        }
      }
    },

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    mouseLeave() {
      if (this.layoutConfig("aside.self.minimize.hoverable")) {
        if (document.body.classList.contains("aside-fixed")) {
          if (this.insideTm) {
            clearTimeout(this.insideTm);
            this.insideTm = null;
          }

          if (document.querySelector(".aside-menu .scroll")) {
            document.querySelector(".aside-menu .scroll").scrollTop = 0;
          }

          // if the left aside menu is expand
          // if (document.body.classList.contains("aside-minimize-hover")) {
          //   // hide back the left aside menu
          //   document.body.classList.remove("aside-minimize-hover");
          //   document.body.classList.add("aside-minimize");
          // }
        }
      }
    },
    toggleAside() {
      const icon = document.getElementById("toggle-icon");
      if (document.body.classList.contains("aside-minimize")) {
        document.body.classList.remove("aside-minimize");
        icon.classList.remove("fa-chevron-right");
        icon.classList.add("fa-chevron-left");
      } else {
        document.body.classList.add("aside-minimize");
        icon.classList.remove("fa-chevron-left");
        icon.classList.add("fa-chevron-right");
      }
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Get extra classes for menu based on the options
     */
    asideMenuClass() {
      const classes = this.getClasses("aside_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },
  },
};
</script>

<style scoped>
#kt_aside_menu .toggle-button {
  position: absolute;
  top: 15px;
  right: 0;
  width: auto;
  display: flex;
  justify-content: end;
  align-content: center;
  z-index: 1;
}

.brand-logo {
  position: relative;
  z-index: 2;
}

.custom-toggle-btn i {
  color: #b5b5c3;
}

.custom-toggle-btn:hover i {
  color: #3699ff;
}
</style>
